module.exports = __webpack_public_path__ + "img/about-top-image.78d41733.png";